import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

function OfferInfo({ shouldShowOfferInfo, offersCount }) {
  if (!shouldShowOfferInfo) {
    return null;
  }

  if (offersCount === 0) {
    return <div className="offersInfo">No offers at this time</div>;
  }

  return <div className="offersInfo">{offersCount} offer{offersCount > 1 ? 's' : ''} available</div>;
}

export default (props) => <ComponentErrorBoundary><OfferInfo {...props} /></ComponentErrorBoundary>;
